import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  DialogContent,
  FormControl,
  Select,
  MenuItem,
  Grid,
  DialogActions,
  Button,
  TextField,
} from "@mui/material";
import InfoIcon from "@mui/icons-material/Info";
import ToastPopup from "../ToastPopup";
import { goBack } from "../../Redux/Actions/InputData";

function CreateFolder(props: any) {
  //const [isFolderExisted, setisFolderExisted] = React.useState(false);
  const isFolderExisted = useSelector(
    (state: any) => state.InputDataReducers.isFolderExisted,
  );
  const [isNext, setIsNext] = React.useState(false);
  const dispatch: any = useDispatch();

  const handleGoBack = () => {
    dispatch(goBack());
    setIsNext(false);
  };
  return (
    <>
      <DialogContent className="modal-body">
        <div className="create-folder">
          <div>
            <label>Folder name*</label>
            <TextField
              id="outlined-basic"
              placeholder="Enter Folder name"
              className="create-folder-text"
              variant="outlined"
              value={props.inputFolderName}
              onChange={props.handleInputFolderName}
            />
          </div>
          <FormControl fullWidth>
            <label>
              Folder time period* <InfoIcon className="info-Icon" />
            </label>
            <Select
              id="select-folder"
              className="select-folder-field"
              placeholder="Select folder time period"
              value={props.selectFolderTimePeriod}
              onChange={props.handleSelectTimePeriod}
            >
              <MenuItem value="Weekly">
                <Grid container spacing={1}>
                  <Grid item xs={6} md={6} lg={6} style={{ float: "right" }}>
                    <span>Weekly</span>
                  </Grid>
                </Grid>
              </MenuItem>
              <MenuItem value="Quraterly">
                <Grid container spacing={1}>
                  <Grid item xs={6} md={6} lg={6}>
                    <span>Quraterly</span>
                  </Grid>
                </Grid>
              </MenuItem>
              <MenuItem value="Monthly">
                <Grid container spacing={1}>
                  <Grid item xs={6} md={6} lg={6} style={{ float: "right" }}>
                    <span>Monthly</span>
                  </Grid>
                </Grid>
              </MenuItem>
              <MenuItem value="Anually">
                <Grid container spacing={1}>
                  <Grid item xs={6} md={6} lg={6}>
                    <span>Anually</span>
                  </Grid>
                </Grid>
              </MenuItem>
            </Select>
          </FormControl>
        </div>
        {isFolderExisted && (
          <ToastPopup message={"Folder is existed"} type="error" />
        )}
      </DialogContent>
      <DialogActions>
        <div className="modal-action">
          <Button variant="outlined" className="cancel" onClick={handleGoBack}>
            Go Back
          </Button>
          {props.inputFolderName && props.selectFolderTimePeriod ? (
            <Button
              variant="contained"
              className="Create-new-folder"
              onClick={props.handleCreateNewFolder}
            >
              Create new folder
            </Button>
          ) : (
            <Button variant="contained" className="disabled-proc-btn">
              Create new folder
            </Button>
          )}
        </div>
      </DialogActions>
    </>
  );
}

export default CreateFolder;
